import { setContext } from '@apollo/client/link/context'
import { getCookie } from 'utils/cookies'

export const authLink = setContext(({ variables }, { headers }) => {
  const token = getCookie('access_token')
  const removeJWTFromHeader = variables?.removeJWTFromHeader

  const authorization = token && !removeJWTFromHeader ? `Bearer ${token}` : null

  return {
    headers: {
      ...headers,
      authorization
    }
  }
})
